import { App } from 'vue';
import { TranslationService } from '../../../modules';
import { TranslationServiceConfiguration } from '../../../modules';
import { ITranslationData } from '../../../modules/translation/translation-data.definition';
import { WindowWithTranslationGlobals } from '../../../modules/translation/translation-globals.window-definition';

export class TranslationPlugin {

    private static globalVariables: { [key: string]: string } = (window as WindowWithTranslationGlobals & typeof globalThis).globalTranslationVariables;
    private static globalVarRegEx = /(\w+)/g;

    public static decorateWithParams(
        translation: string,
        data: ITranslationData
    ): string {
        let map: Map<string, string>;
        const start = data.identifierStart ? data.identifierStart : '{var}';
        const end = data.identifierEnd ? data.identifierEnd : '{/var}';

        if (data.keyValues !== undefined) {
            map = new Map(Object.entries(JSON.parse(data.keyValues)));
            map.forEach((value, key) => {
                translation = translation.replace(`${start}${key}${end}`, value);
            });
        }

        if (this.globalVarRegEx.test(translation)) {
            Object.keys(this.globalVariables).forEach(varKey => {
                const variable = `%${varKey}%`;

                if (translation.indexOf(variable) !== -1) {
                    translation = translation.replace(variable, this.globalVariables[varKey]);
                }
            });
        }

        return translation;
    }

    constructor(private configuration: TranslationServiceConfiguration) {
    }

    public install(app: App, options?: []): void {
        // Assign global $translationService prop
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const plugin = this;
        const serviceId = TranslationService.identifier;
        const translationService = TranslationService.getInstance(this.configuration);

        // Provide Translation service on translationService DI prop
        app.config.globalProperties[serviceId] = translationService;
        app.provide('translationService', translationService);

        // Assign translation directive
        app.directive('translate', async function(el, binding) {
            const translationData: ITranslationData = binding.value || {key: ''};

            try {
                const translations = await translationService.getTranslations();
                let hit = translations[translationData.key];

                if (!hit) {
                    el.innerHTML = `i18n:missing:${translationData.key}`;
                    el.style.wordBreak = 'break-word';
                    return;
                }

                hit = TranslationService.decorateParams(hit, translationData);
                hit = translationData.lowercase ? plugin.toLowercase(hit) : hit;

                el.innerHTML = hit;
            } catch (error) {
                console.error(`Something went wrong with translation retrieval: ${error}`);
            }
        });
    }

    private toLowercase(str: string): string {
        return str.charAt(0).toLowerCase() + str.slice(1);
    }

}
